export const LABELS = {
  BOOKING_DETAILS: "Booking Details",
  FORGOT_IRCTC_PASSWORD: "I forgot IRCTC Password",
  DIFFERENT_IRCTC_USERNAME: "Get a different IRCTC username",
  CAPTCHA: "What is Captcha?",
  CANCEL_BOOKING: "I want to cancel the booking",
  WRONG_CREDENTIALS: "Wrong Credentials",
  OTHER_ISSUES: "Other Issues",
  OTHER_ISSUES_PLACEHOLDER: "Share your story of this train journey and help millions of travellers choose the right train",
  GET_NEW_PASSWORD: "GET NEW PASSWORD",
  GET_NEW_USERNAME: "GET NEW USERNAME",
  NEED_HELP: "Need Help",
  CAPTCHA_LINE_1: `'Captcha' is a test that helps IRCTC identify you as a real human and not a robot.`,
  CAPTCHA_LINE_2: `Simply type out the letters you see in the box, and click ‘submit’.`,
  CAPTCHA_LINE_3: `Please note: The above image is for reference only. You will receive a different set of letters as Captcha.`,
  CONTINUE_BOOKING: "CONTINUE BOOKING",
  API_FAILURE_MESSAGE: 'Unable to fetch data at this moment.',
  FEEDBACK_PLACEHOLDER: 'Please type your feedback here.',
};
